
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7455"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7455"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("88jT0", function(module, exports) {

$parcel$export(module.exports, "initSession", () => $5ebe7f0c0238a2ab$export$403ed9a23f6abb2d);
// src/utils/session.js

var $aCdVm = parcelRequire("aCdVm");

var $1LTkm = parcelRequire("1LTkm");

var $iqWLU = parcelRequire("iqWLU");
const $5ebe7f0c0238a2ab$var$RULES_KEY = "irecruit_rules_v1";
async function $5ebe7f0c0238a2ab$export$403ed9a23f6abb2d() {
    // apply cached rules fast (optional)
    const cached = $5ebe7f0c0238a2ab$var$loadCachedRules();
    if (cached) (0, $1LTkm.setAbilityFromPacked)(cached);
    try {
        // http.get returns the parsed JSON body OR throws {status, message, data}
        const data = await (0, $aCdVm.http).get("/users/me");
        // Expected: { success: true, user: {...}, ability: { version, rules: [...] } }
        console.log("data", data);
        if (!data?.user || !data?.ability?.rules) {
            // unexpected shape -> force re-login
            (0, $iqWLU.logout)();
            return;
        }
        // keep auth store in sync (role/email might change)
        const auth = (0, $iqWLU.getAuthData)();
        if (auth?.token) (0, $iqWLU.setAuth)({
            token: auth.token,
            user: data.user
        });
        (0, $1LTkm.setAbilityFromPacked)(data.ability.rules);
        $5ebe7f0c0238a2ab$var$cacheRules(data.ability.rules);
        return {
            user: data.user,
            ability: (0, $1LTkm.getAbility)()
        };
    } catch (err) {
        // http.js already normalized this error
        console.error("initSession failed:", err);
        if (err.status === 401) {
            (0, $iqWLU.logout)();
            return;
        }
        // Surface a friendly message or rethrow
        throw new Error(err.message || "Failed to load session");
    }
}
function $5ebe7f0c0238a2ab$var$cacheRules(packed) {
    try {
        localStorage.setItem($5ebe7f0c0238a2ab$var$RULES_KEY, JSON.stringify(packed));
    } catch  {}
}
function $5ebe7f0c0238a2ab$var$loadCachedRules() {
    try {
        return JSON.parse(localStorage.getItem($5ebe7f0c0238a2ab$var$RULES_KEY));
    } catch  {
        return null;
    }
}

});
parcelRegister("1LTkm", function(module, exports) {

$parcel$export(module.exports, "getAbility", () => $14a51915b280ca8f$export$51b0c51f5b2e9c35);
$parcel$export(module.exports, "setAbilityFromPacked", () => $14a51915b280ca8f$export$25a8fde56d5596fe);
// src/utils/ability.js

var $7DCe2 = parcelRequire("7DCe2");

var $lyDDg = parcelRequire("lyDDg");
let $14a51915b280ca8f$var$ability = (0, $7DCe2.createMongoAbility)([]); // start empty
function $14a51915b280ca8f$export$51b0c51f5b2e9c35() {
    return $14a51915b280ca8f$var$ability;
}
function $14a51915b280ca8f$export$25a8fde56d5596fe(packedRules) {
    // packedRules should be the array you got from /auth/me -> ability.rules
    $14a51915b280ca8f$var$ability = (0, $7DCe2.createMongoAbility)((0, $lyDDg.unpackRules)(packedRules || []));
}
function $14a51915b280ca8f$export$888b5a8acfa6136a() {
    $14a51915b280ca8f$var$ability = (0, $7DCe2.createMongoAbility)([]);
}
// (optional) expose for quick debugging in the browser console
if (typeof window !== "undefined") window.__getAbility = $14a51915b280ca8f$export$51b0c51f5b2e9c35;

});
parcelRegister("7DCe2", function(module, exports) {

$parcel$export(module.exports, "createMongoAbility", () => createMongoAbility);
parcelRequire("4OfP6");
var $ayBQJ = parcelRequire("ayBQJ");
var $01uQd = parcelRequire("01uQd");
var $4OfP6 = parcelRequire("4OfP6");
function _(t, r) {
    for(var i = 0; i < r.length; i++){
        var n = r[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, B(n.key), n);
    }
}
function C(t, r, i) {
    return r && _(t.prototype, r), i && _(t, i), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
function P() {
    return P = Object.assign ? Object.assign.bind() : function(t) {
        for(var r = 1; r < arguments.length; r++){
            var i = arguments[r];
            for(var n in i)({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, P.apply(null, arguments);
}
function S(t, r) {
    t.prototype = Object.create(r.prototype), t.prototype.constructor = t, T(t, r);
}
function T(t, r) {
    return T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, r) {
        return t.__proto__ = r, t;
    }, T(t, r);
}
function k(t, r) {
    if ("object" != typeof t || !t) return t;
    var i = t[Symbol.toPrimitive];
    if (void 0 !== i) {
        var n = i.call(t, r || "default");
        if ("object" != typeof n) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function B(t) {
    var r = k(t, "string");
    return "symbol" == typeof r ? r : r + "";
}
function R(t) {
    return Array.isArray(t) ? t : [
        t
    ];
}
var q = "__caslSubjectType__";
function z(t, r) {
    if (r) {
        if (!Object.hasOwn(r, q)) Object.defineProperty(r, q, {
            value: t
        });
        else if (t !== r[q]) throw new Error("Trying to cast object to subject type " + t + " but previously it was casted to " + r[q]);
    }
    return r;
}
var Y = function t(r) {
    var i = typeof r;
    return i === "string" || i === "function";
};
var D = function t(r) {
    return r.modelName || r.name;
};
function L(t) {
    return typeof t === "string" ? t : D(t);
}
function N(t) {
    if (Object.hasOwn(t, q)) return t[q];
    return D(t.constructor);
}
var G = {
    function: function t(r) {
        return r.constructor;
    },
    string: N
};
function H(t, r, i) {
    var n = R(r);
    var e = 0;
    while(e < n.length){
        var o = n[e++];
        if (Object.hasOwn(t, o)) n = i(n, t[o]);
    }
    return n;
}
function I(t, r) {
    if (typeof r === "string" && t.indexOf(r) !== -1) return r;
    for(var i = 0; i < r.length; i++)if (t.indexOf(r[i]) !== -1) return r[i];
    return null;
}
var J = function t(r, i) {
    return r.concat(i);
};
function K(t, r) {
    if (r in t) throw new Error('Cannot use "' + r + "\" as an alias because it's reserved action.");
    var i = Object.keys(t);
    var n = function t(i, n) {
        var e = I(i, n);
        if (e) throw new Error("Detected cycle " + e + " -> " + i.join(", "));
        var o = typeof n === "string" && n === r || i.indexOf(r) !== -1 || Array.isArray(n) && n.indexOf(r) !== -1;
        if (o) throw new Error('Cannot make an alias to "' + r + '" because this is reserved action');
        return i.concat(n);
    };
    for(var e = 0; e < i.length; e++)H(t, i[e], n);
}
function Q(t, r) {
    if (!r || r.skipValidate !== false) K(t, r && r.anyAction || "manage");
    return function(r) {
        return H(t, r, J);
    };
}
function U(t, r, i) {
    for(var n = i; n < r.length; n++)t.push(r[n]);
}
function V(t, r) {
    if (!t || !t.length) return r || [];
    if (!r || !r.length) return t || [];
    var i = 0;
    var n = 0;
    var e = [];
    while(i < t.length && n < r.length)if (t[i].priority < r[n].priority) {
        e.push(t[i]);
        i++;
    } else {
        e.push(r[n]);
        n++;
    }
    U(e, t, i);
    U(e, r, n);
    return e;
}
function W(t, r, i) {
    var n = t.get(r);
    if (!n) {
        n = i();
        t.set(r, n);
    }
    return n;
}
var X = function t(r) {
    return r;
};
function Z(t, r) {
    if (Array.isArray(t.fields) && !t.fields.length) throw new Error("`rawRule.fields` cannot be an empty array. https://bit.ly/390miLa");
    if (t.fields && !r.fieldMatcher) throw new Error('You need to pass "fieldMatcher" option in order to restrict access by fields');
    if (t.conditions && !r.conditionsMatcher) throw new Error('You need to pass "conditionsMatcher" option in order to restrict access by conditions');
}
var tt = function() {
    function t(t, r, i) {
        if (i === void 0) i = 0;
        Z(t, r);
        this.action = r.resolveAction(t.action);
        this.subject = t.subject;
        this.inverted = !!t.inverted;
        this.conditions = t.conditions;
        this.reason = t.reason;
        this.origin = t;
        this.fields = t.fields ? R(t.fields) : void 0;
        this.priority = i;
        this.t = r;
    }
    var r = t.prototype;
    r.i = function t() {
        if (this.conditions && !this.o) this.o = this.t.conditionsMatcher(this.conditions);
        return this.o;
    };
    r.matchesConditions = function t(r) {
        if (!this.conditions) return true;
        if (!r || Y(r)) return !this.inverted;
        var i = this.i();
        return i(r);
    };
    r.matchesField = function t(r) {
        if (!this.fields) return true;
        if (!r) return !this.inverted;
        if (!this.u) this.u = this.t.fieldMatcher(this.fields);
        return this.u(r);
    };
    return C(t, [
        {
            key: "ast",
            get: function t() {
                var r = this.i();
                return r ? r.ast : void 0;
            }
        }
    ]);
}();
function rt(t, r) {
    var i = {
        value: t,
        prev: r,
        next: null
    };
    if (r) r.next = i;
    return i;
}
function it(t) {
    if (t.next) t.next.prev = t.prev;
    if (t.prev) t.prev.next = t.next;
    t.next = t.prev = null;
}
var nt = function t(r) {
    return {
        value: r.value,
        prev: r.prev,
        next: r.next
    };
};
var et = function t() {
    return {
        rules: [],
        merged: false
    };
};
var ot = function t() {
    return new Map;
};
var ut = function() {
    function t(t, r) {
        if (t === void 0) t = [];
        if (r === void 0) r = {};
        this.h = false;
        this.v = new Map;
        this.l = {
            conditionsMatcher: r.conditionsMatcher,
            fieldMatcher: r.fieldMatcher,
            resolveAction: r.resolveAction || X
        };
        this.p = r.anyAction || "manage";
        this.A = r.anySubjectType || "all";
        this.j = t;
        this.m = !!r.detectSubjectType;
        this.M = r.detectSubjectType || N;
        this.$(t);
    }
    var r = t.prototype;
    r.detectSubjectType = function t(r) {
        if (Y(r)) return r;
        if (!r) return this.A;
        return this.M(r);
    };
    r.update = function t(r) {
        var i = {
            rules: r,
            ability: this,
            target: this
        };
        this.O("update", i);
        this.j = r;
        this.$(r);
        this.O("updated", i);
        return this;
    };
    r.$ = function t(r) {
        var i = new Map;
        var n;
        for(var e = r.length - 1; e >= 0; e--){
            var o = r.length - e - 1;
            var u = new tt(r[e], this.l, o);
            var f = R(u.action);
            var a = R(u.subject || this.A);
            if (!this.h && u.fields) this.h = true;
            for(var s = 0; s < a.length; s++){
                var c = W(i, a[s], ot);
                if (n === void 0) n = typeof a[s];
                if (typeof a[s] !== n && n !== "mixed") n = "mixed";
                for(var h = 0; h < f.length; h++)W(c, f[h], et).rules.push(u);
            }
        }
        this.v = i;
        if (n !== "mixed" && !this.m) {
            var v = G[n] || G.string;
            this.M = v;
        }
    };
    r.possibleRulesFor = function t(r, i) {
        if (i === void 0) i = this.A;
        if (!Y(i)) throw new Error('"possibleRulesFor" accepts only subject types (i.e., string or class) as the 2nd parameter');
        var n = W(this.v, i, ot);
        var e = W(n, r, et);
        if (e.merged) return e.rules;
        var o = r !== this.p && n.has(this.p) ? n.get(this.p).rules : void 0;
        var u = V(e.rules, o);
        if (i !== this.A) u = V(u, this.possibleRulesFor(r, this.A));
        e.rules = u;
        e.merged = true;
        return u;
    };
    r.rulesFor = function t(r, i, n) {
        var e = this.possibleRulesFor(r, i);
        if (n && typeof n !== "string") throw new Error("The 3rd, `field` parameter is expected to be a string. See https://stalniy.github.io/casl/en/api/casl-ability#can-of-pure-ability for details");
        if (!this.h) return e;
        return e.filter(function(t) {
            return t.matchesField(n);
        });
    };
    r.actionsFor = function t(r) {
        if (!Y(r)) throw new Error('"actionsFor" accepts only subject types (i.e., string or class) as a parameter');
        var i = new Set;
        var n = this.v.get(r);
        if (n) Array.from(n.keys()).forEach(function(t) {
            return i.add(t);
        });
        var e = r !== this.A ? this.v.get(this.A) : void 0;
        if (e) Array.from(e.keys()).forEach(function(t) {
            return i.add(t);
        });
        return Array.from(i);
    };
    r.on = function t(r, i) {
        this.F = this.F || new Map;
        var n = this.F;
        var e = n.get(r) || null;
        var o = rt(i, e);
        n.set(r, o);
        return function() {
            var t = n.get(r);
            if (!o.next && !o.prev && t === o) n.delete(r);
            else if (o === t) n.set(r, o.prev);
            it(o);
        };
    };
    r.O = function t(r, i) {
        if (!this.F) return;
        var n = this.F.get(r) || null;
        while(n !== null){
            var e = n.prev ? nt(n.prev) : null;
            n.value(i);
            n = e;
        }
    };
    return C(t, [
        {
            key: "rules",
            get: function t() {
                return this.j;
            }
        }
    ]);
}();
var ft = function(t) {
    function PureAbility() {
        return t.apply(this, arguments) || this;
    }
    S(PureAbility, t);
    var r = PureAbility.prototype;
    r.can = function t(r, i, n) {
        var e = this.relevantRuleFor(r, i, n);
        return !!e && !e.inverted;
    };
    r.relevantRuleFor = function t(r, i, n) {
        var e = this.detectSubjectType(i);
        var o = this.rulesFor(r, e, n);
        for(var u = 0, f = o.length; u < f; u++)if (o[u].matchesConditions(i)) return o[u];
        return null;
    };
    r.cannot = function t(r, i, n) {
        return !this.can(r, i, n);
    };
    return PureAbility;
}(ut);
var at = {
    $eq: (0, $ayBQJ.$eq),
    $ne: (0, $ayBQJ.$ne),
    $lt: (0, $ayBQJ.$lt),
    $lte: (0, $ayBQJ.$lte),
    $gt: (0, $ayBQJ.$gt),
    $gte: (0, $ayBQJ.$gte),
    $in: (0, $ayBQJ.$in),
    $nin: (0, $ayBQJ.$nin),
    $all: (0, $ayBQJ.$all),
    $size: (0, $ayBQJ.$size),
    $regex: (0, $ayBQJ.$regex),
    $options: (0, $ayBQJ.$options),
    $elemMatch: (0, $ayBQJ.$elemMatch),
    $exists: (0, $ayBQJ.$exists)
};
var st = {
    eq: (0, $01uQd.eq),
    ne: (0, $01uQd.ne),
    lt: (0, $01uQd.lt),
    lte: (0, $01uQd.lte),
    gt: (0, $01uQd.gt),
    gte: (0, $01uQd.gte),
    in: (0, $01uQd.within),
    nin: (0, $01uQd.nin),
    all: (0, $01uQd.all),
    size: (0, $01uQd.size),
    regex: (0, $01uQd.regex),
    elemMatch: (0, $01uQd.elemMatch),
    exists: (0, $01uQd.exists),
    and: (0, $01uQd.and)
};
var ct = function r(i, n, e) {
    return (0, $4OfP6.createFactory)(P({}, at, i), P({}, st, n), e);
};
var ht = (0, $4OfP6.createFactory)(at, st);
var vt = /[-/\\^$+?.()|[\]{}]/g;
var lt = /\.?\*+\.?/g;
var dt = /\*+/;
var yt = /\./g;
function bt(t, r, i) {
    var n = i[0] === "*" || t[0] === "." && t[t.length - 1] === "." ? "+" : "*";
    var e = t.indexOf("**") === -1 ? "[^.]" : ".";
    var o = t.replace(yt, "\\$&").replace(dt, e + n);
    return r + t.length === i.length ? "(?:" + o + ")?" : o;
}
function pt(t, r, i) {
    if (t === "." && (i[r - 1] === "*" || i[r + 1] === "*")) return t;
    return "\\" + t;
}
function wt(t) {
    var r = t.map(function(t) {
        return t.replace(vt, pt).replace(lt, bt);
    });
    var i = r.length > 1 ? "(?:" + r.join("|") + ")" : r[0];
    return new RegExp("^" + i + "$");
}
var gt = function t(r) {
    var i;
    return function(t) {
        if (typeof i === "undefined") i = r.every(function(t) {
            return t.indexOf("*") === -1;
        }) ? null : wt(r);
        return i === null ? r.indexOf(t) !== -1 : i.test(t);
    };
};
var At = function(t) {
    function Ability(r, i) {
        if (r === void 0) r = [];
        if (i === void 0) i = {};
        return t.call(this, r, P({
            conditionsMatcher: ht,
            fieldMatcher: gt
        }, i)) || this;
    }
    S(Ability, t);
    return Ability;
}(ft);
function createMongoAbility(t, r) {
    if (t === void 0) t = [];
    if (r === void 0) r = {};
    return new ft(t, P({
        conditionsMatcher: ht,
        fieldMatcher: gt
    }, r));
}
function isAbilityClass(t) {
    return t.prototype !== void 0 && typeof t.prototype.possibleRulesFor === "function";
}
var jt = function() {
    function t(t) {
        this._ = t;
    }
    var r = t.prototype;
    r.because = function t(r) {
        this._.reason = r;
        return this;
    };
    return t;
}();
var mt = function() {
    function AbilityBuilder(t) {
        var r = this;
        this.rules = [];
        this.C = t;
        this.can = function(t, i, n, e) {
            return r.P(t, i, n, e, false);
        };
        this.cannot = function(t, i, n, e) {
            return r.P(t, i, n, e, true);
        };
        this.build = function(t) {
            return isAbilityClass(r.C) ? new r.C(r.rules, t) : r.C(r.rules, t);
        };
    }
    var t = AbilityBuilder.prototype;
    t.P = function t(r, i, n, e, o) {
        var u = {
            action: r
        };
        if (o) u.inverted = o;
        if (i) {
            u.subject = i;
            if (Array.isArray(n) || typeof n === "string") u.fields = n;
            else if (typeof n !== "undefined") u.conditions = n;
            if (typeof e !== "undefined") u.conditions = e;
        }
        this.rules.push(u);
        return new jt(u);
    };
    return AbilityBuilder;
}();
function defineAbility(t, r) {
    var i = new mt(createMongoAbility);
    var n = t(i.can, i.cannot);
    if (n && typeof n.then === "function") return n.then(function() {
        return i.build(r);
    });
    return i.build(r);
}
var Et = function t(r) {
    return 'Cannot execute "' + r.action + '" on "' + r.subjectType + '"';
};
var Mt = function t(r) {
    this.message = r;
};
Mt.prototype = Object.create(Error.prototype);
var $t = function(t) {
    function ForbiddenError(r) {
        var i;
        i = t.call(this, "") || this;
        i.ability = r;
        if (typeof Error.captureStackTrace === "function") {
            i.name = "ForbiddenError";
            Error.captureStackTrace(i, i.constructor);
        }
        return i;
    }
    S(ForbiddenError, t);
    ForbiddenError.setDefaultMessage = function t(r) {
        this.S = typeof r === "string" ? function() {
            return r;
        } : r;
    };
    ForbiddenError.from = function t(r) {
        return new this(r);
    };
    var r = ForbiddenError.prototype;
    r.setMessage = function t(r) {
        this.message = r;
        return this;
    };
    r.throwUnlessCan = function t(r, i, n) {
        var e = this.unlessCan(r, i, n);
        if (e) throw e;
    };
    r.unlessCan = function t(r, i, n) {
        var e = this.ability.relevantRuleFor(r, i, n);
        if (e && !e.inverted) return;
        this.action = r;
        this.subject = i;
        this.subjectType = L(this.ability.detectSubjectType(i));
        this.field = n;
        var o = e ? e.reason : "";
        this.message = this.message || o || this.constructor.S(this);
        return this;
    };
    return ForbiddenError;
}(Mt);
$t.S = Et;
var Ot = Object.freeze({
    __proto__: null
});

});
parcelRegister("4OfP6", function(module, exports) {
$parcel$export(module.exports, "$all", () => (parcelRequire("ayBQJ")).$all);
$parcel$export(module.exports, "$elemMatch", () => (parcelRequire("ayBQJ")).$elemMatch);
$parcel$export(module.exports, "$eq", () => (parcelRequire("ayBQJ")).$eq);
$parcel$export(module.exports, "$exists", () => (parcelRequire("ayBQJ")).$exists);
$parcel$export(module.exports, "$gt", () => (parcelRequire("ayBQJ")).$gt);
$parcel$export(module.exports, "$gte", () => (parcelRequire("ayBQJ")).$gte);
$parcel$export(module.exports, "$in", () => (parcelRequire("ayBQJ")).$in);
$parcel$export(module.exports, "$lt", () => (parcelRequire("ayBQJ")).$lt);
$parcel$export(module.exports, "$lte", () => (parcelRequire("ayBQJ")).$lte);
$parcel$export(module.exports, "$ne", () => (parcelRequire("ayBQJ")).$ne);
$parcel$export(module.exports, "$nin", () => (parcelRequire("ayBQJ")).$nin);
$parcel$export(module.exports, "$options", () => (parcelRequire("ayBQJ")).$options);
$parcel$export(module.exports, "$regex", () => (parcelRequire("ayBQJ")).$regex);
$parcel$export(module.exports, "$size", () => (parcelRequire("ayBQJ")).$size);
$parcel$export(module.exports, "allParsingInstructions", () => (parcelRequire("ayBQJ")).allParsingInstructions);
$parcel$export(module.exports, "MongoQueryParser", () => (parcelRequire("ayBQJ")).MongoQueryParser);
$parcel$export(module.exports, "all", () => (parcelRequire("01uQd")).all);
$parcel$export(module.exports, "allInterpreters", () => (parcelRequire("01uQd")).allInterpreters);
$parcel$export(module.exports, "and", () => (parcelRequire("01uQd")).and);
$parcel$export(module.exports, "compare", () => (parcelRequire("01uQd")).compare);
$parcel$export(module.exports, "createJsInterpreter", () => (parcelRequire("01uQd")).createJsInterpreter);
$parcel$export(module.exports, "elemMatch", () => (parcelRequire("01uQd")).elemMatch);
$parcel$export(module.exports, "eq", () => (parcelRequire("01uQd")).eq);
$parcel$export(module.exports, "exists", () => (parcelRequire("01uQd")).exists);
$parcel$export(module.exports, "gt", () => (parcelRequire("01uQd")).gt);
$parcel$export(module.exports, "gte", () => (parcelRequire("01uQd")).gte);
$parcel$export(module.exports, "lt", () => (parcelRequire("01uQd")).lt);
$parcel$export(module.exports, "lte", () => (parcelRequire("01uQd")).lte);
$parcel$export(module.exports, "ne", () => (parcelRequire("01uQd")).ne);
$parcel$export(module.exports, "nin", () => (parcelRequire("01uQd")).nin);
$parcel$export(module.exports, "regex", () => (parcelRequire("01uQd")).regex);
$parcel$export(module.exports, "size", () => (parcelRequire("01uQd")).size);
$parcel$export(module.exports, "within", () => (parcelRequire("01uQd")).within);

$parcel$export(module.exports, "createFactory", () => $38081b1b70bc0c22$export$d38cd72104c1f0e9);

var $aBtKn = parcelRequire("aBtKn");

var $ayBQJ = parcelRequire("ayBQJ");
var $aBtKn = parcelRequire("aBtKn");

var $01uQd = parcelRequire("01uQd");
function $38081b1b70bc0c22$var$i() {
    return ($38081b1b70bc0c22$var$i = Object.assign || function(r) {
        for(var t = 1; t < arguments.length; t++){
            var o = arguments[t];
            for(var n in o)Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
        }
        return r;
    }).apply(this, arguments);
}
function $38081b1b70bc0c22$var$a(r) {
    return null === r || "object" != typeof r ? r : r instanceof Date ? r.getTime() : r && "function" == typeof r.toJSON ? r.toJSON() : r;
}
var $38081b1b70bc0c22$var$m = function(r, t) {
    return (0, $01uQd.compare)($38081b1b70bc0c22$var$a(r), $38081b1b70bc0c22$var$a(t));
};
function $38081b1b70bc0c22$export$d38cd72104c1f0e9(n, e, u) {
    var c = new (0, $ayBQJ.MongoQueryParser)(n), a = (0, $01uQd.createJsInterpreter)(e, $38081b1b70bc0c22$var$i({
        compare: $38081b1b70bc0c22$var$m
    }, u));
    if (u && u.forPrimitives) {
        var p = {
            field: (0, $aBtKn.ITSELF)
        }, s = c.parse;
        c.setParse(function(r) {
            return s(r, p);
        });
    }
    return (0, $aBtKn.createTranslatorFactory)(c.parse, a);
}
var $38081b1b70bc0c22$export$864d727b48066337 = $38081b1b70bc0c22$export$d38cd72104c1f0e9((0, $ayBQJ.allParsingInstructions), (0, $01uQd.allInterpreters)), $38081b1b70bc0c22$export$a5dc3f87568676f9 = $38081b1b70bc0c22$export$d38cd72104c1f0e9([
    "$and",
    "$or"
].reduce(function(r, t) {
    return r[t] = $38081b1b70bc0c22$var$i({}, r[t], {
        type: "field"
    }), r;
}, $38081b1b70bc0c22$var$i({}, (0, $ayBQJ.allParsingInstructions), {
    $nor: $38081b1b70bc0c22$var$i({}, (0, $ayBQJ.allParsingInstructions).$nor, {
        type: "field",
        parse: (0, $aBtKn.defaultInstructionParsers).compound
    })
})), (0, $01uQd.allInterpreters), {
    forPrimitives: !0
}), $38081b1b70bc0c22$export$3dea766d36a8935f = $38081b1b70bc0c22$export$864d727b48066337;
$parcel$exportWildcard(module.exports, $aBtKn);

});
parcelRegister("aBtKn", function(module, exports) {

$parcel$export(module.exports, "CompoundCondition", () => o);
$parcel$export(module.exports, "ITSELF", () => u);
$parcel$export(module.exports, "FieldCondition", () => f);
$parcel$export(module.exports, "NULL_CONDITION", () => a);
$parcel$export(module.exports, "optimizedCompoundCondition", () => h);
$parcel$export(module.exports, "buildAnd", () => y);
$parcel$export(module.exports, "buildOr", () => O);
$parcel$export(module.exports, "defaultInstructionParsers", () => j);
$parcel$export(module.exports, "ObjectQueryParser", () => _);
$parcel$export(module.exports, "createInterpreter", () => E);
$parcel$export(module.exports, "createTranslatorFactory", () => x);
function t(t, r) {
    for(var n = 0; n < r.length; n++){
        var i = r[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
}
function r() {
    return (r = Object.assign || function(t) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        }
        return t;
    }).apply(this, arguments);
}
function n(t, r) {
    t.prototype = Object.create(r.prototype), t.prototype.constructor = t, t.__proto__ = r;
}
var i = function() {
    function r(t, r) {
        this.operator = t, this.value = r, Object.defineProperty(this, "t", {
            writable: !0
        });
    }
    var n, i, e;
    return r.prototype.addNote = function(t) {
        this.t = this.t || [], this.t.push(t);
    }, n = r, i = [
        {
            key: "notes",
            get: function() {
                return this.t;
            }
        }
    ], t(n.prototype, i), e && t(n, e), r;
}(), e = function(t) {
    function r() {
        return t.apply(this, arguments) || this;
    }
    return n(r, t), r;
}(i), o = function(t) {
    function r(r, n) {
        if (!Array.isArray(n)) throw new Error('"' + r + '" operator expects to receive an array of conditions');
        return t.call(this, r, n) || this;
    }
    return n(r, t), r;
}(e), u = "__itself__", f = function(t) {
    function r(r, n, i) {
        var e;
        return (e = t.call(this, r, i) || this).field = n, e;
    }
    return n(r, t), r;
}(i), a = new e("__null__", null), c = Object.prototype.hasOwnProperty.call.bind(Object.prototype.hasOwnProperty);
function s(t, r) {
    return r instanceof o && r.operator === t;
}
function h(t, r) {
    return 1 === r.length ? r[0] : new o(t, function t(r, n, i) {
        for(var e = i || [], o = 0, u = n.length; o < u; o++){
            var f = n[o];
            s(r, f) ? t(r, f.value, e) : e.push(f);
        }
        return e;
    }(t, r));
}
var v = function(t) {
    return t;
}, d = function() {
    return Object.create(null);
}, l = Object.defineProperty(d(), "__@type@__", {
    value: "ignore value"
});
function p(t, r, n) {
    if (void 0 === n && (n = !1), !t || t && t.constructor !== Object) return !1;
    for(var i in t){
        if (c(t, i) && c(r, i) && (!n || t[i] !== l)) return !0;
    }
    return !1;
}
function w(t) {
    var r = [];
    for(var n in t)c(t, n) && t[n] !== l && r.push(n);
    return r;
}
function b(t, r) {
    r !== a && t.push(r);
}
var y = function(t) {
    return h("and", t);
}, O = function(t) {
    return h("or", t);
}, j = {
    compound: function(t, r, n) {
        var i = (Array.isArray(r) ? r : [
            r
        ]).map(function(t) {
            return n.parse(t);
        });
        return new o(t.name, i);
    },
    field: function(t, r, n) {
        return new f(t.name, n.field, r);
    },
    document: function(t, r) {
        return new e(t.name, r);
    }
}, _ = function() {
    function t(t, n) {
        var i = this;
        void 0 === n && (n = d()), this.i = void 0, this.o = void 0, this.u = void 0, this.s = void 0, this.h = void 0, this.parse = this.parse.bind(this), this.s = {
            operatorToConditionName: n.operatorToConditionName || v,
            defaultOperatorName: n.defaultOperatorName || "eq",
            mergeFinalConditions: n.mergeFinalConditions || y
        }, this.i = Object.keys(t).reduce(function(n, e) {
            return n[e] = r({
                name: i.s.operatorToConditionName(e)
            }, t[e]), n;
        }, {}), this.o = r({}, n.fieldContext, {
            field: "",
            query: {},
            parse: this.parse,
            hasOperators: function(t) {
                return p(t, i.i, n.useIgnoreValue);
            }
        }), this.u = r({}, n.documentContext, {
            parse: this.parse,
            query: {}
        }), this.h = n.useIgnoreValue ? w : Object.keys;
    }
    var n = t.prototype;
    return n.setParse = function(t) {
        this.parse = t, this.o.parse = t, this.u.parse = t;
    }, n.parseField = function(t, r, n, i) {
        var e = this.i[r];
        if (!e) throw new Error('Unsupported operator "' + r + '"');
        if ("field" !== e.type) throw new Error("Unexpected " + e.type + ' operator "' + r + '" at field level');
        return this.o.field = t, this.o.query = i, this.parseInstruction(e, n, this.o);
    }, n.parseInstruction = function(t, r, n) {
        return "function" == typeof t.validate && t.validate(t, r), (t.parse || j[t.type])(t, r, n);
    }, n.parseFieldOperators = function(t, r) {
        for(var n = [], i = this.h(r), e = 0, o = i.length; e < o; e++){
            var u = i[e];
            if (!this.i[u]) throw new Error('Field query for "' + t + '" may contain only operators or a plain object as a value');
            b(n, this.parseField(t, u, r[u], r));
        }
        return n;
    }, n.parse = function(t) {
        var r = [], n = this.h(t);
        this.u.query = t;
        for(var i = 0, e = n.length; i < e; i++){
            var o = n[i], u = t[o], f = this.i[o];
            if (f) {
                if ("document" !== f.type && "compound" !== f.type) throw new Error('Cannot use parsing instruction for operator "' + o + '" in "document" context as it is supposed to be used in  "' + f.type + '" context');
                b(r, this.parseInstruction(f, u, this.u));
            } else this.o.hasOperators(u) ? r.push.apply(r, this.parseFieldOperators(o, u)) : b(r, this.parseField(o, this.s.defaultOperatorName, u, t));
        }
        return this.s.mergeFinalConditions(r);
    }, t;
}();
function m(t, r) {
    var n = t[r];
    if ("function" != typeof n) throw new Error('Unable to interpret "' + r + '" condition. Did you forget to register interpreter for it?');
    return n;
}
function g(t) {
    return t.operator;
}
function E(t, n) {
    var i, e = n, o = e && e.getInterpreterName || g;
    switch(e ? e.numberOfArguments : 0){
        case 1:
            i = function(r) {
                var n = o(r, e);
                return m(t, n)(r, u);
            };
            break;
        case 3:
            i = function(r, n, i) {
                var f = o(r, e);
                return m(t, f)(r, n, i, u);
            };
            break;
        default:
            i = function(r, n) {
                var i = o(r, e);
                return m(t, i)(r, n, u);
            };
    }
    var u = r({}, e, {
        interpret: i
    });
    return u.interpret;
}
function x(t, r) {
    return function(n) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)e[o - 1] = arguments[o];
        var u = t.apply(void 0, [
            n
        ].concat(e)), f = r.bind(null, u);
        return f.ast = u, f;
    };
}
var q = _.prototype.parseInstruction;

});

parcelRegister("ayBQJ", function(module, exports) {

$parcel$export(module.exports, "$elemMatch", () => $7afa707d11645a78$export$3c13d805ffeb95a9);
$parcel$export(module.exports, "$size", () => $7afa707d11645a78$export$c49f2dc9c9999b69);
$parcel$export(module.exports, "$in", () => $7afa707d11645a78$export$8245ce74a32da367);
$parcel$export(module.exports, "$nin", () => $7afa707d11645a78$export$ce88b5b49e3e2b1a);
$parcel$export(module.exports, "$all", () => $7afa707d11645a78$export$43aa869a31554d83);
$parcel$export(module.exports, "$exists", () => $7afa707d11645a78$export$ceffb6260a0caa7b);
$parcel$export(module.exports, "$gte", () => $7afa707d11645a78$export$498e9eedb7f04fd);
$parcel$export(module.exports, "$gt", () => $7afa707d11645a78$export$1f550262df26845f);
$parcel$export(module.exports, "$lt", () => $7afa707d11645a78$export$773e7ed20df4ad88);
$parcel$export(module.exports, "$lte", () => $7afa707d11645a78$export$4ff63c7a7bf7dedf);
$parcel$export(module.exports, "$eq", () => $7afa707d11645a78$export$6061bac2a420197a);
$parcel$export(module.exports, "$ne", () => $7afa707d11645a78$export$aa35552cb11abad1);
$parcel$export(module.exports, "$regex", () => $7afa707d11645a78$export$10458b6f41814382);
$parcel$export(module.exports, "$options", () => $7afa707d11645a78$export$58733f68cae0f62f);
$parcel$export(module.exports, "MongoQueryParser", () => $7afa707d11645a78$export$20862a63ee6eb7e4);
$parcel$export(module.exports, "allParsingInstructions", () => $7afa707d11645a78$export$ccda072b6052dafc);

var $aBtKn = parcelRequire("aBtKn");
function $7afa707d11645a78$var$f(e, t) {
    if (!Array.isArray(t)) throw new Error('"' + e.name + '" expects value to be an array');
}
function $7afa707d11645a78$var$u(e, t) {
    if ($7afa707d11645a78$var$f(e, t), !t.length) throw new Error('"' + e.name + '" expects to have at least one element in array');
}
var $7afa707d11645a78$var$c = function(e) {
    return function(t, r) {
        if (typeof r !== e) throw new Error('"' + t.name + '" expects value to be a "' + e + '"');
    };
}, $7afa707d11645a78$export$1bc7defe66dc7543 = {
    type: "compound",
    validate: $7afa707d11645a78$var$u,
    parse: function(t, r, n) {
        var o = n.parse, a = r.map(function(e) {
            return o(e);
        });
        return (0, $aBtKn.optimizedCompoundCondition)(t.name, a);
    }
}, $7afa707d11645a78$export$146c88c7025eceff = $7afa707d11645a78$export$1bc7defe66dc7543, $7afa707d11645a78$export$704aa7249533c635 = {
    type: "compound",
    validate: $7afa707d11645a78$var$u
}, $7afa707d11645a78$export$b1e8a7e1a63ec3d1 = {
    type: "field",
    validate: function(e, t) {
        if (!(t && (t instanceof RegExp || t.constructor === Object))) throw new Error('"' + e.name + '" expects to receive either regular expression or object of field operators');
    },
    parse: function(e, n, o) {
        var a = n instanceof RegExp ? new (0, $aBtKn.FieldCondition)("regex", o.field, n) : o.parse(n, o);
        return new (0, $aBtKn.CompoundCondition)(e.name, [
            a
        ]);
    }
}, $7afa707d11645a78$export$3c13d805ffeb95a9 = {
    type: "field",
    validate: function(e, t) {
        if (!t || t.constructor !== Object) throw new Error('"' + e.name + '" expects to receive an object with nested query or field level operators');
    },
    parse: function(e, r, o) {
        var a = o.parse, i = o.field, f = (0, o.hasOperators)(r) ? a(r, {
            field: (0, $aBtKn.ITSELF)
        }) : a(r);
        return new (0, $aBtKn.FieldCondition)(e.name, i, f);
    }
}, $7afa707d11645a78$export$c49f2dc9c9999b69 = {
    type: "field",
    validate: $7afa707d11645a78$var$c("number")
}, $7afa707d11645a78$export$8245ce74a32da367 = {
    type: "field",
    validate: $7afa707d11645a78$var$f
}, $7afa707d11645a78$export$ce88b5b49e3e2b1a = $7afa707d11645a78$export$8245ce74a32da367, $7afa707d11645a78$export$43aa869a31554d83 = $7afa707d11645a78$export$8245ce74a32da367, $7afa707d11645a78$export$a7f2ec9af91b1cfe = {
    type: "field",
    validate: function(e, t) {
        if (!Array.isArray(t) || 2 !== t.length) throw new Error('"' + e.name + '" expects an array with 2 numeric elements');
    }
}, $7afa707d11645a78$export$ceffb6260a0caa7b = {
    type: "field",
    validate: $7afa707d11645a78$var$c("boolean")
}, $7afa707d11645a78$export$498e9eedb7f04fd = {
    type: "field",
    validate: function(e, t) {
        if (!("string" == typeof t || "number" == typeof t || t instanceof Date)) throw new Error('"' + e.name + '" expects value to be comparable (i.e., string, number or date)');
    }
}, $7afa707d11645a78$export$1f550262df26845f = $7afa707d11645a78$export$498e9eedb7f04fd, $7afa707d11645a78$export$773e7ed20df4ad88 = $7afa707d11645a78$export$1f550262df26845f, $7afa707d11645a78$export$4ff63c7a7bf7dedf = $7afa707d11645a78$export$1f550262df26845f, $7afa707d11645a78$export$6061bac2a420197a = {
    type: "field"
}, $7afa707d11645a78$export$aa35552cb11abad1 = $7afa707d11645a78$export$6061bac2a420197a, $7afa707d11645a78$export$10458b6f41814382 = {
    type: "field",
    validate: function(e, t) {
        if (!(t instanceof RegExp) && "string" != typeof t) throw new Error('"' + e.name + '" expects value to be a regular expression or a string that represents regular expression');
    },
    parse: function(e, r, n) {
        var o = "string" == typeof r ? new RegExp(r, n.query.$options || "") : r;
        return new (0, $aBtKn.FieldCondition)(e.name, n.field, o);
    }
}, $7afa707d11645a78$export$58733f68cae0f62f = {
    type: "field",
    parse: function() {
        return 0, $aBtKn.NULL_CONDITION;
    }
}, $7afa707d11645a78$export$7ad60cd6f80e7a3f = {
    type: "document",
    validate: $7afa707d11645a78$var$c("function")
}, $7afa707d11645a78$var$N = Object.freeze({
    __proto__: null,
    $and: $7afa707d11645a78$export$1bc7defe66dc7543,
    $or: $7afa707d11645a78$export$146c88c7025eceff,
    $nor: $7afa707d11645a78$export$704aa7249533c635,
    $not: $7afa707d11645a78$export$b1e8a7e1a63ec3d1,
    $elemMatch: $7afa707d11645a78$export$3c13d805ffeb95a9,
    $size: $7afa707d11645a78$export$c49f2dc9c9999b69,
    $in: $7afa707d11645a78$export$8245ce74a32da367,
    $nin: $7afa707d11645a78$export$ce88b5b49e3e2b1a,
    $all: $7afa707d11645a78$export$43aa869a31554d83,
    $mod: $7afa707d11645a78$export$a7f2ec9af91b1cfe,
    $exists: $7afa707d11645a78$export$ceffb6260a0caa7b,
    $gte: $7afa707d11645a78$export$498e9eedb7f04fd,
    $gt: $7afa707d11645a78$export$1f550262df26845f,
    $lt: $7afa707d11645a78$export$773e7ed20df4ad88,
    $lte: $7afa707d11645a78$export$4ff63c7a7bf7dedf,
    $eq: $7afa707d11645a78$export$6061bac2a420197a,
    $ne: $7afa707d11645a78$export$aa35552cb11abad1,
    $regex: $7afa707d11645a78$export$10458b6f41814382,
    $options: $7afa707d11645a78$export$58733f68cae0f62f,
    $where: $7afa707d11645a78$export$7ad60cd6f80e7a3f
});
var $7afa707d11645a78$export$20862a63ee6eb7e4 = function(e) {
    var t, r;
    function n(t) {
        return e.call(this, t, {
            defaultOperatorName: "$eq",
            operatorToConditionName: function(e) {
                return e.slice(1);
            }
        }) || this;
    }
    return r = e, (t = n).prototype = Object.create(r.prototype), t.prototype.constructor = t, t.__proto__ = r, n.prototype.parse = function(t, r) {
        return r && r.field ? (0, $aBtKn.buildAnd)(this.parseFieldOperators(r.field, t)) : e.prototype.parse.call(this, t);
    }, n;
}((0, $aBtKn.ObjectQueryParser)), $7afa707d11645a78$export$ccda072b6052dafc = $7afa707d11645a78$var$N;

});

parcelRegister("01uQd", function(module, exports) {

$parcel$export(module.exports, "compare", () => $004804846cdd0909$export$398604a469f7de9a);
$parcel$export(module.exports, "createJsInterpreter", () => $004804846cdd0909$export$33ce502ef10df4f6);
$parcel$export(module.exports, "and", () => $004804846cdd0909$export$21c0ac7fe1cef1b8);
$parcel$export(module.exports, "eq", () => $004804846cdd0909$export$9663ddc1cf085b32);
$parcel$export(module.exports, "ne", () => $004804846cdd0909$export$8216a600ee4a21ad);
$parcel$export(module.exports, "lte", () => $004804846cdd0909$export$489c007ed603c05d);
$parcel$export(module.exports, "lt", () => $004804846cdd0909$export$b961576059b7aeb6);
$parcel$export(module.exports, "gt", () => $004804846cdd0909$export$dafeacbfe3530cd9);
$parcel$export(module.exports, "gte", () => $004804846cdd0909$export$aac79e834d1b4aed);
$parcel$export(module.exports, "exists", () => $004804846cdd0909$export$f7e9f41ea797a17);
$parcel$export(module.exports, "size", () => $004804846cdd0909$export$346677f925de839c);
$parcel$export(module.exports, "regex", () => $004804846cdd0909$export$17b0f4d84dbfeedf);
$parcel$export(module.exports, "within", () => $004804846cdd0909$export$f28d906d67a997f3);
$parcel$export(module.exports, "nin", () => $004804846cdd0909$export$ef5273e061b138c7);
$parcel$export(module.exports, "all", () => $004804846cdd0909$export$84bf76cd7afc7469);
$parcel$export(module.exports, "elemMatch", () => $004804846cdd0909$export$17bdc0b0d0760adf);
$parcel$export(module.exports, "allInterpreters", () => $004804846cdd0909$export$cfe7e2af8207bc55);

var $aBtKn = parcelRequire("aBtKn");
function $004804846cdd0909$var$t(r, n, t) {
    for(var u = 0, e = r.length; u < e; u++)if (0 === t(r[u], n)) return !0;
    return !1;
}
function $004804846cdd0909$var$u(r, n) {
    return Array.isArray(r) && Number.isNaN(Number(n));
}
function $004804846cdd0909$var$e(r, n, t) {
    if (!$004804846cdd0909$var$u(r, n)) return t(r, n);
    for(var e = [], o = 0; o < r.length; o++){
        var i = t(r[o], n);
        void 0 !== i && (e = e.concat(i));
    }
    return e;
}
function $004804846cdd0909$var$o(r) {
    return function(n, t, u) {
        var e = u.get(t, n.field);
        return Array.isArray(e) ? e.some(function(t) {
            return r(n, t, u);
        }) : r(n, e, u);
    };
}
function $004804846cdd0909$var$i() {
    return ($004804846cdd0909$var$i = Object.assign || function(r) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var u in t)Object.prototype.hasOwnProperty.call(t, u) && (r[u] = t[u]);
        }
        return r;
    }).apply(this, arguments);
}
var $004804846cdd0909$var$f = function(r, n) {
    return r[n];
};
function $004804846cdd0909$export$2320699f7b72222c(r, n, t) {
    var u = n.lastIndexOf(".");
    return -1 === u ? [
        r,
        n
    ] : [
        t(r, n.slice(0, u)),
        n.slice(u + 1)
    ];
}
function $004804846cdd0909$export$a21615afe49439a6(n, t, u) {
    if (void 0 === u && (u = $004804846cdd0909$var$f), t === (0, $aBtKn.ITSELF)) return n;
    if (!n) throw new Error('Unable to get field "' + t + '" out of ' + String(n) + ".");
    return function(r, n, t) {
        if (-1 === n.indexOf(".")) return $004804846cdd0909$var$e(r, n, t);
        for(var u = n.split("."), o = r, i = 0, f = u.length; i < f; i++)if (!(o = $004804846cdd0909$var$e(o, u[i], t)) || "object" != typeof o) return o;
        return o;
    }(n, t, u);
}
function $004804846cdd0909$export$a249a49553433c6f(r) {
    return function(n, t) {
        return $004804846cdd0909$export$a21615afe49439a6(n, t, r);
    };
}
function $004804846cdd0909$export$398604a469f7de9a(r, n) {
    return r === n ? 0 : r > n ? 1 : -1;
}
function $004804846cdd0909$export$33ce502ef10df4f6(r, t) {
    return void 0 === t && (t = {}), (0, $aBtKn.createInterpreter)(r, $004804846cdd0909$var$i({
        get: $004804846cdd0909$export$a21615afe49439a6,
        compare: $004804846cdd0909$export$398604a469f7de9a
    }, t));
}
var $004804846cdd0909$export$252bb8b3bbdf6749 = function(r, n, t) {
    var u = t.interpret;
    return r.value.some(function(r) {
        return u(r, n);
    });
}, $004804846cdd0909$export$2aaefb809f21d3ce = function(r, n, t) {
    return !$004804846cdd0909$export$252bb8b3bbdf6749(r, n, t);
}, $004804846cdd0909$export$21c0ac7fe1cef1b8 = function(r, n, t) {
    var u = t.interpret;
    return r.value.every(function(r) {
        return u(r, n);
    });
}, $004804846cdd0909$export$6003a5f097c73977 = function(r, n, t) {
    return !(0, t.interpret)(r.value[0], n);
}, $004804846cdd0909$export$9663ddc1cf085b32 = function(r, n, u) {
    var e = u.compare, o = (0, u.get)(n, r.field);
    return Array.isArray(o) && !Array.isArray(r.value) ? $004804846cdd0909$var$t(o, r.value, e) : 0 === e(o, r.value);
}, $004804846cdd0909$export$8216a600ee4a21ad = function(r, n, t) {
    return !$004804846cdd0909$export$9663ddc1cf085b32(r, n, t);
}, $004804846cdd0909$export$489c007ed603c05d = $004804846cdd0909$var$o(function(r, n, t) {
    var u = t.compare(n, r.value);
    return 0 === u || -1 === u;
}), $004804846cdd0909$export$b961576059b7aeb6 = $004804846cdd0909$var$o(function(r, n, t) {
    return -1 === t.compare(n, r.value);
}), $004804846cdd0909$export$dafeacbfe3530cd9 = $004804846cdd0909$var$o(function(r, n, t) {
    return 1 === t.compare(n, r.value);
}), $004804846cdd0909$export$aac79e834d1b4aed = $004804846cdd0909$var$o(function(r, n, t) {
    var u = t.compare(n, r.value);
    return 0 === u || 1 === u;
}), $004804846cdd0909$export$f7e9f41ea797a17 = function(n, t, e) {
    var o = e.get;
    if (n.field === (0, $aBtKn.ITSELF)) return void 0 !== t;
    var i = $004804846cdd0909$export$2320699f7b72222c(t, n.field, o), f = i[0], a = i[1], v = function(r) {
        return null == r ? Boolean(r) === n.value : r.hasOwnProperty(a) === n.value;
    };
    return $004804846cdd0909$var$u(f, a) ? f.some(v) : v(f);
}, $004804846cdd0909$export$842a2cf37af977e1 = $004804846cdd0909$var$o(function(r, n) {
    return "number" == typeof n && n % r.value[0] === r.value[1];
}), $004804846cdd0909$export$346677f925de839c = function(n, t, e) {
    var o = e.get, i = $004804846cdd0909$export$2320699f7b72222c(t, n.field, o), f = i[0], a = i[1], v = function(r) {
        var t = o(r, a);
        return Array.isArray(t) && t.length === n.value;
    };
    return n.field !== (0, $aBtKn.ITSELF) && $004804846cdd0909$var$u(f, a) ? f.some(v) : v(f);
}, $004804846cdd0909$export$17b0f4d84dbfeedf = $004804846cdd0909$var$o(function(r, n) {
    return "string" == typeof n && r.value.test(n);
}), $004804846cdd0909$export$f28d906d67a997f3 = $004804846cdd0909$var$o(function(r, n, u) {
    var e = u.compare;
    return $004804846cdd0909$var$t(r.value, n, e);
}), $004804846cdd0909$export$ef5273e061b138c7 = function(r, n, t) {
    return !$004804846cdd0909$export$f28d906d67a997f3(r, n, t);
}, $004804846cdd0909$export$84bf76cd7afc7469 = function(r, n, u) {
    var e = u.compare, o = (0, u.get)(n, r.field);
    return Array.isArray(o) && r.value.every(function(r) {
        return $004804846cdd0909$var$t(o, r, e);
    });
}, $004804846cdd0909$export$17bdc0b0d0760adf = function(r, n, t) {
    var u = t.interpret, e = (0, t.get)(n, r.field);
    return Array.isArray(e) && e.some(function(n) {
        return u(r.value, n);
    });
}, $004804846cdd0909$export$9c59b80dda569a6e = function(r, n) {
    return r.value.call(n);
}, $004804846cdd0909$export$cfe7e2af8207bc55 = $004804846cdd0909$var$i({}, Object.freeze({
    __proto__: null,
    or: $004804846cdd0909$export$252bb8b3bbdf6749,
    nor: $004804846cdd0909$export$2aaefb809f21d3ce,
    and: $004804846cdd0909$export$21c0ac7fe1cef1b8,
    not: $004804846cdd0909$export$6003a5f097c73977,
    eq: $004804846cdd0909$export$9663ddc1cf085b32,
    ne: $004804846cdd0909$export$8216a600ee4a21ad,
    lte: $004804846cdd0909$export$489c007ed603c05d,
    lt: $004804846cdd0909$export$b961576059b7aeb6,
    gt: $004804846cdd0909$export$dafeacbfe3530cd9,
    gte: $004804846cdd0909$export$aac79e834d1b4aed,
    exists: $004804846cdd0909$export$f7e9f41ea797a17,
    mod: $004804846cdd0909$export$842a2cf37af977e1,
    size: $004804846cdd0909$export$346677f925de839c,
    regex: $004804846cdd0909$export$17b0f4d84dbfeedf,
    within: $004804846cdd0909$export$f28d906d67a997f3,
    nin: $004804846cdd0909$export$ef5273e061b138c7,
    all: $004804846cdd0909$export$84bf76cd7afc7469,
    elemMatch: $004804846cdd0909$export$17bdc0b0d0760adf,
    where: $004804846cdd0909$export$9c59b80dda569a6e
}), {
    in: $004804846cdd0909$export$f28d906d67a997f3
}), $004804846cdd0909$export$67beed298888a38b = $004804846cdd0909$export$33ce502ef10df4f6($004804846cdd0909$export$cfe7e2af8207bc55);

});



parcelRegister("lyDDg", function(module, exports) {

$parcel$export(module.exports, "unpackRules", () => $fb1b841c93bc9912$export$cd83af172e1cd0f1);

var $aBtKn = parcelRequire("aBtKn");
function $fb1b841c93bc9912$var$i(r) {
    return Array.isArray(r) ? r : [
        r
    ];
}
function $fb1b841c93bc9912$var$e(r, n, t) {
    var i = r;
    var e = n;
    if (n.indexOf(".") !== -1) {
        var u = n.split(".");
        e = u.pop();
        i = u.reduce(function(r, n) {
            r[n] = r[n] || {};
            return r[n];
        }, r);
    }
    i[e] = t;
}
var $fb1b841c93bc9912$var$u = function r(n) {
    return Array.isArray(n) ? n.join(",") : n;
};
function $fb1b841c93bc9912$export$16ac513902a386b5(r, n) {
    return r.map(function(r) {
        var t = [
            $fb1b841c93bc9912$var$u(r.action || r.actions),
            typeof n === "function" ? $fb1b841c93bc9912$var$i(r.subject).map(n).join(",") : $fb1b841c93bc9912$var$u(r.subject),
            r.conditions || 0,
            r.inverted ? 1 : 0,
            r.fields ? $fb1b841c93bc9912$var$u(r.fields) : 0,
            r.reason || ""
        ];
        while(t.length > 0 && !t[t.length - 1])t.pop();
        return t;
    });
}
function $fb1b841c93bc9912$export$cd83af172e1cd0f1(r, n) {
    return r.map(function(r) {
        var t = r[0], i = r[1], e = r[2], u = r[3], o = r[4], f = r[5];
        var a = i.split(",");
        var c = {
            inverted: !!u,
            action: t.split(","),
            subject: typeof n === "function" ? a.map(n) : a
        };
        if (e) c.conditions = e;
        if (o) c.fields = o.split(",");
        if (f) c.reason = f;
        return c;
    });
}
function $fb1b841c93bc9912$export$468d41661ab64f01(r, n, t, i) {
    var e = r.detectSubjectType(t);
    var u = r.possibleRulesFor(n, e);
    var o = new Set;
    var f = o.delete.bind(o);
    var a = o.add.bind(o);
    var c = u.length;
    while(c--){
        var v = u[c];
        if (v.matchesConditions(t)) {
            var s = v.inverted ? f : a;
            i.fieldsFrom(v).forEach(s);
        }
    }
    return Array.from(o);
}
var $fb1b841c93bc9912$export$fa706fe746b66490 = function() {
    function r(r, n, t) {
        this.t = r;
        this.i = n;
        this.u = t;
    }
    var n = r.prototype;
    n.ofType = function r(n) {
        return $fb1b841c93bc9912$export$468d41661ab64f01(this.t, this.i, n, {
            fieldsFrom: this.o(n)
        });
    };
    n.of = function r(n) {
        return $fb1b841c93bc9912$export$468d41661ab64f01(this.t, this.i, n, {
            fieldsFrom: this.o(this.t.detectSubjectType(n))
        });
    };
    n.o = function r(n) {
        var t = this;
        return function(r) {
            return r.fields || t.u(n);
        };
    };
    return r;
}();
function $fb1b841c93bc9912$export$202a2beb37afb783(r, n, t) {
    return r.rulesFor(n, t).reduce(function(r, n) {
        if (n.inverted || !n.conditions) return r;
        return Object.keys(n.conditions).reduce(function(r, t) {
            var i = n.conditions[t];
            if (!i || i.constructor !== Object) $fb1b841c93bc9912$var$e(r, t, i);
            return r;
        }, r);
    }, {});
}
function $fb1b841c93bc9912$export$d8107686be32cb9e(r, n, t, i) {
    var e = [];
    var u = [];
    var o = r.rulesFor(n, t);
    for(var f = 0; f < o.length; f++){
        var a = o[f];
        var c = a.inverted ? e : u;
        if (!a.conditions) {
            if (a.inverted) break;
            else return e.length ? {
                $and: e
            } : {};
        } else c.push(i(a));
    }
    if (!u.length) return null;
    return e.length ? {
        $or: u,
        $and: e
    } : {
        $or: u
    };
}
function $fb1b841c93bc9912$var$h(r) {
    if (!r.ast) throw new Error('Ability rule "' + JSON.stringify(r) + '" does not have "ast" property. So, cannot be used to generate AST');
    return r.inverted ? new (0, $aBtKn.CompoundCondition)("not", [
        r.ast
    ]) : r.ast;
}
function $fb1b841c93bc9912$export$2d4189df7856a6e(t, i, e) {
    var u = $fb1b841c93bc9912$export$d8107686be32cb9e(t, i, e, $fb1b841c93bc9912$var$h);
    if (u === null) return null;
    if (!u.$and) return u.$or ? (0, $aBtKn.buildOr)(u.$or) : (0, $aBtKn.buildAnd)([]);
    if (u.$or) u.$and.push((0, $aBtKn.buildOr)(u.$or));
    return (0, $aBtKn.buildAnd)(u.$and);
}

});



parcelRegister("gUeH9", function(module, exports) {

$parcel$export(module.exports, "handleError", () => $c4ed466db2dc4339$export$d3da1ecaf1206c58);

var $i7xfM = parcelRequire("i7xfM");

var $em171 = parcelRequire("em171");
function $c4ed466db2dc4339$export$d3da1ecaf1206c58(err, fallbackMessage = "Something went wrong.") {
    console.error("\u274C handleError received:", err);
    let message = fallbackMessage;
    if (typeof err === "string") message = err;
    else if (err instanceof Error) message = err.message;
    else if (err?.message) message = err.message;
    else if (err?.data?.message) message = err.data.message;
    (0, $i7xfM.showError)(message);
    (0, $em171.logError)(err);
}

});
parcelRegister("em171", function(module, exports) {

$parcel$export(module.exports, "logError", () => $a733fba2c1d6c6b5$export$58da9968c3170cb1);
var $a733fba2c1d6c6b5$import_meta = Object.assign(Object.create(null), {
    url: "file:///public/scripts/utils/logger.js"
});
const $a733fba2c1d6c6b5$var$env = $a733fba2c1d6c6b5$import_meta?.env?.MODE || "production";
function $a733fba2c1d6c6b5$export$89c0607256d35f0a(...args) {
    if ($a733fba2c1d6c6b5$var$env === "development") console.info("\u2139\uFE0F [INFO]:", ...args);
}
function $a733fba2c1d6c6b5$export$ebd6064652549ce9(...args) {
    if ($a733fba2c1d6c6b5$var$env === "development") console.warn("\u26A0\uFE0F [WARN]:", ...args);
}
function $a733fba2c1d6c6b5$export$58da9968c3170cb1(...args) {
    if ($a733fba2c1d6c6b5$var$env === "development") console.error("\u274C [ERROR]:", ...args);
}

});



//# sourceMappingURL=login.8f573587.js.map
